import React, { useState, useMemo } from 'react'
import SdfContext from './sdfContext'
import { formatDate } from '../../components/common/utils/date_Utils'
import PropTypes from 'prop-types'

const Sdf_Provider = ({ children }) => {
  const todayDate = new Date()
  const minDate = new Date()
  minDate.setMonth(minDate.getMonth() - 2)
  const [cvCalender, setCvCalender] = useState({
    minDate: minDate,
    maxDate: todayDate,
    selectedWeek: null,
    selectedDate: todayDate,
    weekRangeArray: [],
    weekRange: null,
    displayText: formatDate(todayDate),
  })
  const [brandName, setBrandName] = useState('hm')
  const value = useMemo(
    () => ({
      cvCalender,
      setCvCalender,
      brandName,
      setBrandName,
    }),
    [cvCalender, brandName],
  )
  return <SdfContext.Provider value={value}>{children}</SdfContext.Provider>
}
Sdf_Provider.propTypes = {
  children: PropTypes.node,
}
export default Sdf_Provider
